import React, { useEffect } from 'react'
import Theme from './config/themes/'
import ErrorBoundary from './topics/Error/widgets/ErrorBoundary'
import moment from 'moment'
import ScrollToTop from './components/ScrollToTop'
import ThemeProviderResponsive from './components/ThemeProviderResponsive'
import ReactGA from 'react-ga'
import GlobalStyles from './styles'
import isStolApp, { DEVICES } from './modules/is-stolapp'
import { ArticlesProvider } from './components/ContextArticles'
import Piano from './vendor/Piano'
import AutomaticLogin from './layouts/Default/components/AutomaticLogin'
import Routes from './components/Routes'
import './modules/polyfills'
import isServerSide from './modules/is-server-side'
import { UserProvider } from './components/ContextUser'
import { createCallbackFunction } from './bundles/BundleScriptScheduler'

const app = ({ initialData, ...props }) => {
  useEffect(() => {
    moment.locale('de')
  }, [])

  if (!isServerSide()) {
    createCallbackFunction()
    if (!isStolApp()) {
      ReactGA.initialize(process.env.RAZZLE_UA_TRACKING)
    }
  }

  return (
    <ErrorBoundary view="app" {...props}>
      <Piano />
      <AutomaticLogin />
      <GlobalStyles />
      <ScrollToTop>
        <ThemeProviderResponsive theme={Theme}>
          <ArticlesProvider>
            <UserProvider>
              <Routes initialData={initialData} />
            </UserProvider>
          </ArticlesProvider>
        </ThemeProviderResponsive>
      </ScrollToTop>
    </ErrorBoundary>
  )
}

export default app
